import React, { useEffect, useState } from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { makeStyles } from '@mui/styles';
import { toast } from 'react-toastify';
import { useSelector, useDispatch } from 'react-redux';
import { listAccessibleGroupsAPI } from '../../store/features/listGroup';
import { ReactComponent as Cancel } from "../../assets/images/TicketImages/cancel.svg";
import { ReactComponent as ArrowDropDownIcon } from "../../assets/images/dropdown-arrow.svg";
import { Chip } from '@mui/material';

const useStyles = makeStyles({
  paper: {
    transform: 'none',
    opacity: '1',
    transition:
      'opacity 242ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, transform 161ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
    transformOrigin: '0px 0px',
    background: '#fff',
    color: '#556575',
    fontSize: '14px',
    fontWeight: '400',
    boxShadow:
      '0px 5px 5px -3px rgba(0,0,0,0.2), 0px 8px 10px 1px rgba(0,0,0,0.14), 0px 3px 14px 2px rgba(0,0,0,0.12)',
  },
});

export default function AddGroupInput(props) {
  const [data, setData] = useState([]);
  const [defaultSelectedGroup, setDefaultSelectedGroup] = useState(null);

  const classes = useStyles();
  const dispatch = useDispatch();
  const { setSelectedGroups, selectedGroups } = props;

  const handleGroupChange = (event, newValue) => {
    setSelectedGroups(newValue.map((group) => group.id));
    console.log('Selected Group IDs:', selectedGroups);
  };

  const getGroupsList = async () => {
    try {
      const response = await dispatch(listAccessibleGroupsAPI());

      if (response?.payload?.status === 200) {
        const groups = response.payload.data.map((item) => ({
          id: item?.id,
          name: item?.title,
        }));

        setData(groups);

        // Default to General (last group in the list)
        if (groups.length > 0) {
          const generalGroup = groups[groups.length - 1];
          if (!selectedGroups.includes(generalGroup.id)) {
            setSelectedGroups([generalGroup.id]);
          }
        }
      } else {
        toast.error('Some Error Occured. Please try again later.', {
          position: 'top-right',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: 'light',
        });
      }
    } catch (error) {
      toast.error(error, {
        position: 'top-right',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: 'light',
      });
    }
  };

  useEffect(() => {
    getGroupsList();
  }, []);

  useEffect(() => { }, [data]);

  return (
    <Autocomplete
      multiple
      limitTags={2}
      id="multiple-limit-tags"
      options={data}
      getOptionLabel={(data) => data.name}
      value={data.filter((group) => selectedGroups.includes(group.id))}
      onChange={(event, newValue) =>
        setSelectedGroups(newValue.map((group) => group.id))
      }
      disableClearable
      size="small"
      classes={{ paper: classes.paper }}
      popupIcon={<ArrowDropDownIcon />}
      renderTags={(value, getTagProps) => (
        value.map((option, index) => {
          const { key, ...tagProps } = getTagProps({ index });
          return (
            <Chip
              key={option.id}
              label={option.name}
              deleteIcon={<Cancel />}
              onDelete={() =>
                setSelectedGroups((prev) => prev.filter((id) => id !== option.id))
              }
              sx={{
                height: "24px",
                backgroundColor: "#F9FAFA",
                border: "1px solid #C5CED6",
                "& .MuiChip-label": {
                  fontSize: "12px",
                  color: "#405261",
                  fontWeight: 500,
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                },
              }}
              {...tagProps}
            />
          );
        })
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          sx={{
            '& .MuiInputBase-root': {
              height: 'auto',
              padding: '8px',
            },
            '& .MuiInputBase-input': {
              padding: '2px 4px !important',
              minWidth: '40px',
            },
          }}
        />
      )}
      ListboxProps={{
        style: { maxHeight: 200, overflowY: 'auto' },
        sx: {
          "& .MuiAutocomplete-option": {
            fontSize: "14px !important",
            color: "#556575 !important",
            textTransform: 'capitalize',
            borderRadius: "8px",
            // margin: "2px 4px",
            margin: '0px 8px',

            padding: "8px 8px !important",

            // Hover state
            "&:hover": {
              backgroundColor: "#F9FAFA !important",
              color: "#061522 !important",
            },

            // Keyboard navigation focus
            "&.Mui-focused": {
              backgroundColor: "#F9FAFA !important",
              color: "#061522 !important",
            },

            // Selected state - THIS IS THE KEY FIX
            "&[aria-selected='true']": {
              backgroundColor: "#F9FAFA !important",
              color: "#061522 !important",
              fontWeight: "500 !important",
            },

            // Selected + hover
            "&[aria-selected='true']:hover": {
              backgroundColor: "#F9FAFA !important",
              color: "#061522 !important",
            },

            // Selected + focused (keyboard navigation)
            "&[aria-selected='true'].Mui-focused": {
              backgroundColor: "#F9FAFA !important",
              color: "#061522 !important",
            },
          },
        },
      }}
      sx={{
        fontSize: 12,
        marginTop: '5px',
        minHeight: '32px',
        maxHeight: "160px",
        "& .MuiOutlinedInput-root": {
          minHeight: '32px',
          maxHeight: "160px",
          display: "flex",
          flexWrap: "wrap",
          alignItems: "flex-start",
          overflowY: "auto",
          overflowX: "hidden",
          border: "1px solid #d5dce1",
          transition: "all 0.2s ease",
          "& .MuiOutlinedInput-notchedOutline": { border: "none" },
          "&:hover .MuiOutlinedInput-notchedOutline": { border: "none" },
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": { border: "none" },
          "&::-webkit-scrollbar": { width: "6px" },
          "&::-webkit-scrollbar-thumb": {
            backgroundColor: "#C5CED6",
            borderRadius: "4px",
          },
          scrollbarWidth: "thin",
          "-ms-overflow-style": "none",
        },
        "& .MuiAutocomplete-endAdornment": {
          marginTop: "3px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        },
        "& .MuiAutocomplete-popupIndicator": {
          padding: "2px",
          marginRight: "0px",
        },
      }}
    />
  );
}